import { render } from "./GastosPorCategoria.vue?vue&type=template&id=307f96ee&scoped=true"
import script from "./GastosPorCategoria.vue?vue&type=script&lang=js"
export * from "./GastosPorCategoria.vue?vue&type=script&lang=js"

import "./GastosPorCategoria.vue?vue&type=style&index=0&id=307f96ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307f96ee"]])

export default __exports__